import { Fragment } from "react";

const BOLD = /(__[^_]+__|\*\*[^*]+\*\*)/;

/**
 * A glossary definition as written in the Obsidian vault. Some carry
 * markdown bold (`__Sevak__`, `**On the ten sounds:**`) and a few keep
 * `[[wikilink]]` brackets; show the emphasis and drop the brackets
 * rather than printing the raw markup.
 */
export function Definition({ text }: { text: string }) {
  const clean = text.replace(/\[\[([^\]]+)\]\]/g, "$1");
  return (
    <>
      {clean.split(BOLD).map((part, i) =>
        BOLD.test(part) ? (
          <strong key={i} className="font-semibold">
            {part.slice(2, -2)}
          </strong>
        ) : (
          <Fragment key={i}>{part}</Fragment>
        ),
      )}
    </>
  );
}
